import { NotificationCreate } from './NotificationCreate';
import { NotificationList } from './NotificationList';
import { NotificationShow } from './NotificationShow';

export const list = NotificationList;
export const show = NotificationShow;
export const create = NotificationCreate;
